const Alpha = (color = '#000000', alphaNumber = 0) => {
  if (
    typeof color === 'string' &&
    color.length === 7 &&
    typeof alphaNumber === 'number' &&
    (alphaNumber >= 0 || alphaNumber <= 1)
  ) {
    const hexArr = [color.substr(1, 2), color.substr(3, 2), color.substr(5, 2)];
    const alphaArr = [
      parseInt(hexArr[0], 16),
      parseInt(hexArr[1], 16),
      parseInt(hexArr[2], 16)
    ];

    return `rgba(${alphaArr.join(',')}, ${alphaNumber})`;
  }

  return 'transparent';
};

const GreenTheme = {
  PRIMARY: '#01AEAA',
  PRIMARY_BUTTON: '#3DB67B',
  PRIMARY_BUTTON_ON_HOVER: '#319262',
  SECONDARY: '#F5A225',
  FOOTER_BACKGROUND: '#2C2A28',
  GRAY: ['#666666', '#888888', '#A3A3A3', '#C0C0C0', '#E0E0E0', '#F5F5F5'],
  DANGER: '#EB4C3D',
  WHITE: '#FFFFFF',
  Alpha
};

// padrao fitinsur 2019
// PRIMARY: '#2C2A28',
// SECONDARY: '#FDC830',
// GRAY: ['#666666', '#888888', '#A3A3A3', '#C0C0C0', '#E0E0E0', '#F5F5F5'],
// DANGER: '#EB4C3D',
// WHITE: '#FFFFFF',

// BLUES (Excelsior)
// 002D72 - figma blue - excelsior
// GRAY: [ '#CCCCFF', '#9999FF', '#6666FF', '#3333FF', '#0000FF', '#0000CC', '#000099', '#000066', '#000033' ]
// GRAY: [ '#002D72', '#002D72', '#002D72', '#002D72', '#002D72', '#002D72', '#002D72', '#002D72', '#002D72' ]

// Zurich
// 06065D - figma blue - zurich
// GRAY: [ '#06065D', '#888888', '#A3A3A3', '#06065D', '#E0E0E0', '#06065D', '#06065D', '#06065D', '#06065D' ]

// TEXEL FINANCE
// rosa #D6006E
// verde #6BCABA
// roxo #5C078C

// https://www.w3schools.com/colors/colors_picker.asp

const Colors = {
  PRIMARY1: '#2C2A28',
  PRIMARY: '#FFFFFF',
  PRIMARY2: '#464440',
  SECONDARY1: '#FDC830',
  SECONDARY: '#D6006E',
  GRAY: ['#666666', '#888888', '#A3A3A3', '#C0C0C0', '#E0E0E0', '#F5F5F5', '#53565A', '#F2F2F2'],
  DANGER: '#EB4C3D',
  WHITE: '#FFFFFF',
  BLACK: '#000000',
  RED: 'red',
  PINK: '#D6006E',
  GREEN: '#6BCABA',
  BLUE: '#3A5DAE',
  PURPLE: '#5C078C',
  Alpha
};

const Colors_BKP2 = {
  PRIMARY: '#06065D',
  SECONDARY: '#FDC830',
  GRAY: [ '#06065D', '#888888', '#A3A3A3', '#06065D', '#E0E0E0', '#F5F5F5'],
  GRAY2: ['#666666', '#888888', '#A3A3A3', '#C0C0C0', '#E0E0E0', '#F5F5F5'],
  DANGER: '#EB4C3D',
  WHITE: '#FFFFFF',
  Alpha
};

const Colors_ZURICH = {
  PRIMARY: '#06065D',
  SECONDARY: '#002D72',
  GRAY2: ['#666666', '#888888', '#A3A3A3', '#C0C0C0', '#E0E0E0', '#F5F5F5'],
  GRAY3: [ '#002D72', '#888888', '#A3A3A3', '#002D72', '#E0E0E0', '#002D72', '#002D72', '#002D72', '#002D72' ],
  GRAY: [ '#06065D', '#888888', '#A3A3A3', '#06065D', '#E0E0E0', '#06065D', '#06065D', '#06065D', '#06065D' ],
  BLUE: [ '#e6eeff', '#b3ccff', '#80aaff', ' #4d88ff', '#3377ff', '#0055ff', '#0044cc', '#003399', '#002266' ],
  DANGER: '#EB4C3D',
  WHITE: '#FFFFFF',
  ORANGE: '#FFA500',
  Alpha
};

const Colors_BKP = {
  PRIMARY: '#2C2A28',
  SECONDARY: '#FDC830',
  GRAY: ['#666666', '#888888', '#A3A3A3', '#C0C0C0', '#E0E0E0', '#F5F5F5'],
  DANGER: '#EB4C3D',
  WHITE: '#FFFFFF',
  Alpha
};

export default Colors;

export { GreenTheme };
